/**
 * Ring PRO carousel images per color (carousel-v4).
 * Assets: web_v2/ring-pro/buy-v2/carousel-v4/{desktop,mobile}/<slug>/1..7.png
 */
import { ProductCarouselItem } from 'components/shared/ProductCarousel';
import { DesktopCarouselBanner } from 'components/ring-pro/DesktopCarouselBanner';
import { RingProColors } from './constants';

const CAROUSEL_BASE = 'web_v2/ring-pro/buy-v2/carousel-v4';
const SLIDE_COUNT = 7;

const CAROUSEL_SLUG: Record<RingProColors, string> = {
  [RingProColors.GOLD]: 'bionic-gold',
  [RingProColors.SILVER]: 'space-silver',
  [RingProColors.BLACK]: 'aster-black',
  [RingProColors.TITANIUM]: 'raw-titanium',
};

const buildCarouselItems = (
  color: RingProColors,
): readonly ProductCarouselItem[] => {
  const slug = CAROUSEL_SLUG[color];
  return Array.from({ length: SLIDE_COUNT }, (_, index) => {
    const n = index + 1;
    return {
      src: `${CAROUSEL_BASE}/desktop/${slug}/${n}.png`,
      srcResponsive: `${CAROUSEL_BASE}/mobile/${slug}/${n}.png`,
      objectPositionBottom: false,
      alt: '',
      // Slide 1 carries the desktop-only shipping/warranty overlay.
      ...(n === 1
        ? {
            title: <DesktopCarouselBanner />,
            textPosition: 'top-center' as const,
          }
        : {}),
    };
  });
};

export const RingProCarouselData: Partial<
  Record<RingProColors, readonly ProductCarouselItem[]>
> = {
  [RingProColors.GOLD]: buildCarouselItems(RingProColors.GOLD),
  [RingProColors.SILVER]: buildCarouselItems(RingProColors.SILVER),
  [RingProColors.BLACK]: buildCarouselItems(RingProColors.BLACK),
  [RingProColors.TITANIUM]: buildCarouselItems(RingProColors.TITANIUM),
};
